import { Col, List, Row } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { snakeCase } from 'lodash';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  AdvancedSetting,
  SettingsByGroup,
  SettingsGroup,
} from 'api/advanced-settings/settings-types';
import { Checkbox } from 'components/atoms/checkbox';
import { TitleContainer } from 'components/atoms/module-settings/advanced-settings';

const GroupSubSectionTitle = styled(TitleContainer)`
  border-bottom: none;
`;

export const Content = styled.div`
  border-top: 1px solid var(--gray-20);
  padding: var(--spacing-05);
`;

export const ListItem = styled(List.Item)`
  border-bottom: 0px;
  margin-left: var(--spacing-05);
  padding: 0;
  display: block;

  &:first-child {
    ${Content} {
      border-top: ${(props) =>
        props.title ? '1px solid var(--gray-20)' : 'none'};
    }
  }
`;

export const SettingGroup = ({
  title,
  groupType,
  settingsConfig,
  onSettingChange,
}: {
  title?: string;
  groupType: SettingsGroup;
  settingsConfig: AdvancedSetting[];
  onSettingChange: (value: AdvancedSetting) => void;
}) => {
  const filteredSettingsConfig = useMemo(
    () =>
      settingsConfig
        .filter((settingConfig) =>
          SettingsByGroup[groupType].includes(settingConfig.eventType),
        )
        .sort((a, b) => a.eventType.localeCompare(b.eventType)),
    [groupType, settingsConfig],
  );

  const handleChecked = (e: CheckboxChangeEvent) =>
    onSettingChange({
      eventType: e.target.value,
      eventValue: e.target.checked,
    });

  return (
    <>
      <GroupSubSectionTitle>{title}</GroupSubSectionTitle>
      <List
        dataSource={filteredSettingsConfig}
        renderItem={({ eventType, eventValue }) => (
          <ListItem title={title}>
            <Row align="middle">
              <Col flex="16px">
                <Checkbox
                  value={eventType}
                  checked={eventValue}
                  onChange={handleChecked}
                />
              </Col>
              <Col flex="calc(100% - 32px)">
                <Content>
                  <FormattedMessage
                    id={`settings.advanced.${snakeCase(eventType)}`}
                  />
                </Content>
              </Col>
            </Row>
          </ListItem>
        )}
      />
    </>
  );
};
